import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import * as _ from 'lodash';
import { FormFieldEmailCheckerService } from './form-field-email-checker.service';
import { Club } from '~core/models';
import { CustomerService } from '~core/services';


/**
 * Commponent for password fields
 */
@UntilDestroy()
@Component({
  selector: '[app-form-field-email-checker]',
  templateUrl: './form-field-email-checker.component.html',
  styleUrls: ['./form-field-email-checker.component.scss'],
  host: { class: 'esf-form-item' }
})
export class FormFieldEmailCheckerComponent implements OnInit, OnDestroy {
  public searchInput: any = new Subject<string>();
  public showCheckmark: boolean;
  public editValue: string = null;
  public id: string;
  @Input() public control: AbstractControl;
  @Input() public selectedClub: Club;
  @Input() public optional: boolean = false;
  @Input() public isEdit: boolean = false;
  @Output() public searchResultsEmpty: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  constructor(private customerService: CustomerService, private emailCheckerService: FormFieldEmailCheckerService) { }

  get formControl(): UntypedFormControl {
    return this.control as UntypedFormControl;
  }

  public ngOnInit(): void {
    const debounceSeconds = 600;
    this.searchInput
      .pipe(
        untilDestroyed(this),
        debounceTime(debounceSeconds),
        distinctUntilChanged())
      .subscribe((event: any) => {
        this.searchEmails(event);
      });
    if (this.isEdit) {
      this.editValue = this.control.value;
      this.showCheckmark = this.editValue !== null ? true : false;
    } else if (this.emailCheckerService.emailCheckerValue === this.control.value) {
      this.showCheckmark = true;
    }

    const parent = this.control.parent;
    for (const key of Object.keys(parent.controls)) {
      const childControl = _.get(parent.controls, key);
      if (childControl === this.control) {
        this.id = key;
      }
    }
  }

  /**
   * Executes the search query. If it contains results it will emit false, otherwise true
   */
  public searchEmails(event: any): any {
    let query = '';

    if (this.control.valid && this.control.value) {
      query += `email=${this.control.value}`;

      if (this.isEdit && (this.editValue === this.control.value)) {
        this.searchResultsEmpty.emit(true);
        this.showCheckmark = true;
      } else {
        this.customerService.searchEmail(query, this.selectedClub.id)
          .pipe(untilDestroyed(this))
          .subscribe({
            next: data => {
              this.control.setErrors({ emailExists: true });
            },
            error: (err: Error) => {
              console.log(err);
              this.searchResultsEmpty.emit(true);
              this.showCheckmark = true;
              this.emailCheckerService.emailCheckerValue = this.control.value;
            }
          });
      }
    } else if (this.control.valid && !this.control.value) {
      this.searchResultsEmpty.emit(true);
    }
  }

  /**
   * Emits a false value the moment we enter something;
   */
  public keyDown(event: any): void {
    this.searchResultsEmpty.emit(false);
    this.showCheckmark = false;
  }

  public ngOnDestroy(): void { }

}
